import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LangContext = createContext({ lang: "es", setLang: () => {}, t: translations.es });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      const stored = localStorage.getItem("zenko_lang");
      if (stored === "en" || stored === "es") return stored;
      // Browser default
      const nav = (navigator.language || "es").slice(0, 2);
      return nav === "en" ? "en" : "es";
    } catch (err) {
      // localStorage/navigator not available (SSR, sandboxed iframe, private mode)
      if (typeof console !== "undefined") console.warn("Zenko i18n: language storage unavailable, defaulting to ES", err);
      return "es";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("zenko_lang", lang);
      document.documentElement.lang = lang;
    } catch (err) {
      // Storage may be disabled/full — non-critical, language still works in-memory
      if (typeof console !== "undefined") console.warn("Zenko i18n: could not persist language preference", err);
    }
  }, [lang]);

  const value = { lang, setLang, t: translations[lang] };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
